import { render, staticRenderFns } from "./ChipCuenta.vue?vue&type=template&id=4e390ba8&"
import script from "./ChipCuenta.vue?vue&type=script&lang=js&"
export * from "./ChipCuenta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports